import { LoaderFunctionArgs, redirect } from "react-router-dom";

import { shopFlowPathForRequest } from "modules/standaloneProducts/standaloneProductsPaths";

export function redirectToCart({ request }: LoaderFunctionArgs) {
  const flowPath = shopFlowPathForRequest(request);
  return redirect(flowPath(`/cart${new URL(request.url).search}`));
}
